<div class="p-grid marginzero p-align-center searchSection">
  <div class="p-col-12 p-sm-4">
    <div class="searchCategories">
      <a routerLink="/szukaj" mat-button (click)="goToSearch()" class="specialBackground categoriesButton" id="categoriesBtn">{{ 'notes_list_menu' | translate }}</a>
    </div>
  </div>
  <div class="p-col-12 p-sm-1"></div>
  <!-- <div class="p-col-12 p-sm-1" style="text-align: center; font-size: 20px;">{{ 'main_page_or' | translate }}</div> -->
  <div class="p-col-12 p-sm-7">
    <span class="ui-float-label searchInput">
      <input id="float-input" type="text" size="30" pInputText (keyup.enter)="searchTrack($event)">
      <label for="float-input">{{ 'main_page_enter_title' | translate }}</label>
    </span>
  </div>
</div>

<div style="height: 15px;"></div>

<div class="p-grid marginzero sliderSection">
  <div class="p-col-12 p-sm-12 p-md-12 p-lg-9" style="padding: 0">
   <app-slider></app-slider>
  </div>
  <div class="p-col-12 p-sm-12 p-md-12 p-lg-3 sideContainer blueBackground">
    <a routerLink="/jakkupowac">
      <p>{{ 'main_page_banner1' | translate }}</p>
      <p>{{ 'main_page_banner2' | translate }}</p>
      <p>{{ 'main_page_banner3' | translate }}</p>
      <p>{{ 'main_page_banner4' | translate }}</p>
    </a>
  </div>
</div>

<div class="p-grid marginzero">
  <div class="p-col-12 weAre blueColor">
    <span>{{ 'main_page_banner_footer' | translate }}</span>
  </div>
</div>

<div class="p-grid marginzero">
  <div class="p-col-12">
    <div *ngIf="isLoading" class="p-grid marginzero p-justify-center"><p-progressSpinner></p-progressSpinner></div>
    <div *ngIf="!isLoading" class="p-grid marginzero">
      <div class="p-col-12 p-lg-6">
        <div class="trackListHeader blueBackground">{{ 'main_page_recent' | translate }}</div>
        <app-track-list [trackList]="recentNotes"></app-track-list>
      </div>

      <div class="p-col-12 p-lg-6">
        <div class="trackListHeader blueBackground">{{ 'main_page_bestsellers' | translate }}</div>
        <app-track-list [trackList]="popularNotes"></app-track-list>
      </div>

      <div class="p-col-12">
        <div class="trackListHeader blueBackground" style="width: 100%;">{{ 'main_page_our_arrangers' | translate }}</div>
        <app-arangers-list [arangersList]="arangersList"></app-arangers-list>
      </div>
    </div>
  </div>
</div>

<br>

<div class="p-grid marginzero">
  <div class="p-col-12 blueColor" style="text-align: center;">
    <p style="font-size: 21px; font-weight: 500;">{{ 'main_page_footer1' | translate }}</p>
    <p>{{ 'main_page_footer2' | translate }}</p>
    <p>{{ 'main_page_footer3' | translate }}</p>
  </div>
</div>
